import { Button } from 'react-bootstrap';
import Dropzone, { DropEvent, FileRejection } from 'react-dropzone';
import styled from 'styled-components';

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-width: 2px;
    border-radius: 2px;
    border-color: ${props => getColor(props)};
    border-style: dashed;
    background-color: #fafafa;
    outline: none;
    transition: border .24s ease-in-out;
`;

const getColor = (props) => {
    if (props.isDragAccept) {
        return '#00e676';
    }

    if (props.isDragReject) {
        return '#ff1744';
    }

    if (props.isDragActive) {
        return '#2196f3';
    }

    return '#eeeeee';
};

interface IProps {
    label: string | JSX.Element,
    files: File[],
    height?: string,
    accept?: string | string[],
    singleUploadOnly: boolean,
    onFileDropped: (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => void,
    onRemoveFile: (name: string) => void
}

const FileUpload = (props: IProps) => {
    const height = props.height ? props.height : '50px';

    const showAddOpt =
        props.files != null && props.files.length == 0
        || (props.files != null && props.files.length > 0 && !props.singleUploadOnly);

    const fileExists = props.files != null && props.files.length > 0;

    return (
        <Dropzone
            accept={props.accept}
            onDrop={props.onFileDropped}
            noKeyboard
        >
            {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
                return (
                    <>
                        {showAddOpt &&
                            <Container {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
                                <div style={{ width: '100%', height, display: 'flex', alignItems: 'center' }}>
                                    <div style={{ margin: 'auto', padding: 3, textAlign: 'center', cursor: 'default' }}>
                                        {props.label}
                                    </div>
                                </div>
                                <input {...getInputProps()} />
                            </Container>
                        }

                        {fileExists && (
                            <div style={{ paddingTop: 5, width: '100%', borderTop: showAddOpt ? '1px solid #ddd' : null }}>
                                {props.files.map((file, index) =>
                                    <div key={'file-to-upload-' + index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #ddd', borderRadius: 4, backgroundColor: 'white', padding: 5 }}>
                                        <div style={{ marginRight: 10 }}>{file.name}</div>
                                        <div style={{ display: 'flex' }}>
                                            <Button bsStyle='danger' bsSize='xs' onClick={() => props.onRemoveFile(file.name)}>Remove</Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                );
            }}
        </Dropzone>
    );
}

export default FileUpload;